import React from "react";
import ReactDOM from "react-dom/client";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";

import App from "./App";
import "../node_modules/dstill/dist/output.css";
import "./tailwind-output.css";
import { GlobalContextProvider } from "./context/GlobalContext";
import { ErrorBoundary } from "./enhancers/ErrorBoundary";

console.error(`Print Connect Registration Form is Running. Build time: ${new Date().toISOString()}`);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <GlobalContextProvider>
      <ErrorBoundary>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </ErrorBoundary>
    </GlobalContextProvider>
  </React.StrictMode>
);
